<template lang="pug">
  b-row.mb-5
    b-col
      router-view(@address-changed='reloadOrganizationsPanel')
</template>

<script>
export default {
  name: 'manager-organizations-address',
  methods: {
    reloadOrganizationsPanel() {
      this.$parent.$refs.organizationsPanel.panelReload()
    },
  },
}
</script>
